import styled from 'styled-components';

export const EmptyState = styled.div`
  color: var(--color-text-muted);
  font-size: 12px;
`;
